import Translate from '@/filters/translate'

export default {
  name: 'meta-description',
  computed: {
    description () {
      let d = this.$route.meta.desc
      if (d) {
        d = Translate.translate(d)
        d = d.replace(/\{\{poster\}\}/g, this.$store.getters.posterName)
        d = d.replace(/\{\{artist\}\}/g, this.$store.getters.posterArtist)
        return d
      }
      return ''
    }
  },
  mounted () {
    let el = this.$el
    this.$el.remove()
    document.querySelector('head').appendChild(el)
  }
}



// WEBPACK FOOTER //
// ./src/components/meta-description/script.js